import { Box, Flex, Text } from 'rebass/styled-components';
import styled from 'styled-components';

import Media from '../../../utils/Media';
import { CategoryCard } from '../../components/Cards';

export const StyledModuleCtaContainer = styled.div`
  ${Media({
    marginTop: ['23px', null, null, '39px'],
  })}
`;

export const StyledModuleHeading = styled.h2`
  color: ${props => props.theme.text.heading.color ?? props.theme.colors.text};
  font-weight: ${props => props.theme.categoryCards.titleFontWeight || 'bold'};
  word-break: break-word;
  font-size: 40px;

  ${Media({
    marginBottom: ['1rem', null, null, '0.5rem'],
  })}
`;

export const StyledModuleHeadingNoDescription = styled.h2`
  color: ${props => props.theme.text.heading.color ?? props.theme.colors.text};
  font-weight: normal;
  word-break: break-word;

  ${Media({
    fontSize: ['2rem', null, null, '2.5rem'],
    marginBottom: ['3rem', null, null, '3.25rem'],
  })}
`;

export const StyledModuleDescription = styled(Text)`
  color: ${props => props.theme.colors.text};
  line-height: 1.5;
  font-size: 1.25rem;

  ${Media({
    marginBottom: ['3rem', null, null, '3.25rem'],
  })}

  ${props =>
    props.variant === 'secondary'
      ? Media({
          marginBottom: ['3.25rem', null, '2rem', '3.25rem'],
          maxWidth: ['none', null, '60%', '50%'],
        })
      : ''}
`;

export const StyledContainer = styled(Box)`
  position: relative;
  max-width: ${props => props.theme.sizes.xl};

  ${Media({
    marginLeft: ['1rem', null, '2rem', '58px'],
    marginRight: ['1rem', null, '2rem', '58px'],
    marginTop: ['56px', null, null, '81px'],
  })};
`;

export const StyledBlueBox = styled(Box)`
  position: absolute;
  width: calc(591 / 1440 * 100%);
  height: 402px;
  top: 0px;
  right: 0px;
  background-color: ${props => props.theme.categoryCards.backgroundColor};
  transform:;
  z-index: -1;

  ${Media({
    marginTop: ['0px', null, '95px', '0px'],
    transform: ['translate(15px, -2.125rem)', null, 'translate(59px, -2rem)'],
    width: [`calc(266 / 375 * 100%)`, null, `calc(591 / 1440 * 100%)`],
  })}
`;

export const StyledCardContainer = styled(Flex)`
  align-items: top;
  justify-content: left;
  margin-bottom: 0px;
  width: 100%;

  ${Media({
    margin: ['0 0 1rem 0', null, '0 -16px 1rem -16px', '0 -16px 0 -16px'],
  })}

  &.cards-2 {
    ${Media({
      width: ['100%', null, null, '66.66%'],
    })}
  }

  &.cards-1 {
    ${Media({
      width: ['100%', null, null, '33.33%'],
    })}
  }

  ${Media({
    flexWrap: ['wrap', null, null, 'wrap'],
    position: ['relative', null, 'static'],
  })}

  > *:last-child {
    ${Media({
      margin: ['0', null, '0 16px 32px'],
    })}
  }

  > *:not(:last-child) {
    ${Media({
      margin: ['0 0px 32px', null, '0 16px 32px', '0 16px 32px'],
    })}
  }
`;

export const StyledCategoryCard = styled(CategoryCard)`
  max-width: none;

  ${Media({
    width: ['100%', null, 'calc(50% - 32px)', 'calc(33.33% - 32px)'],
  })}

  &.cards-2 {
    ${Media({
      width: ['100%', null, 'calc(50% - 32px)', 'calc(50% - 32px)'],
    })}
  }

  &.cards-1 {
    ${Media({
      width: ['100%', null, 'calc(50% - 16px)', '100%'],
    })}
  }
`;

export const StyledCenteredModuleTitle = styled.div`
  max-width: 650px;
  margin: 0 auto;
  h2 {
    ${Media({
      fontSize: ['40px', null, null, '56px'],
    })}
  }
`;
